import {Icon, type CssProperties} from '@sail/ui';

import {getWalletIcon} from 'src/v2/util/getWalletIcon';
import type {
  ExtensionWalletOption,
  WalletConnectOption,
  ExchangeOption,
} from 'src/types';
import {WalletConnectIcon} from './WalletConnectIcon';

interface Props {
  walletOption:
    | Pick<ExtensionWalletOption, 'provider' | 'name'>
    | Pick<WalletConnectOption, 'provider' | 'name' | 'iconUrl'>
    | Pick<ExchangeOption, 'provider' | 'name' | 'iconUrl'>;
  width?: CssProperties['width'];
  height?: CssProperties['height'];
  borderRadius?: CssProperties['borderRadius'];
}

export const WalletIcon = ({
  walletOption,
  width = '44px',
  height = '44px',
  borderRadius = 'large',
}: Props) => {
  const {provider} = walletOption;
  // If no iconUrl is provided, use the WalletConnect icon
  if (
    provider === 'WalletConnect' &&
    'iconUrl' in walletOption &&
    !!walletOption.iconUrl
  ) {
    const {iconUrl, name} = walletOption;
    return (
      <WalletConnectIcon
        iconUrl={iconUrl}
        name={name}
        width={width}
        height={height}
        borderRadius={borderRadius}
      />
    );
  }

  if (provider === 'Exchange') {
    const {iconUrl, name} = walletOption;
    return (
      <WalletConnectIcon
        iconUrl={iconUrl}
        name={name}
        width={width}
        height={height}
        borderRadius={borderRadius}
      />
    );
  }

  return (
    <Icon
      icon={getWalletIcon(provider)}
      css={{
        height,
        width,
        borderRadius,
        alignSelf: 'center',
      }}
    />
  );
};
